import { ReactComponent as PublishSvg } from "./publish-icon.svg";
export const PublishIcon = PublishSvg